
import { Component, Prop, Vue } from "vue-property-decorator";
import { StationSummary } from "@/api/dtos/StationSummary.schema";
import moment from "moment";
import api from "@/api";

type OnlineStatusType = "ONLINE" | "ISSUE" | "OFFLINE";

@Component({
  components: {}
})
export default class StationSummaryFrame extends Vue {
  @Prop({
    default: 290
  })
  width!: number;

  @Prop({
    default: 300
  })
  height!: number;

  @Prop()
  station!: StationSummary;

  stationImage: File | null = null;

  moment = moment;

  async mounted () {
    const stationImage = await api.StationsApi.getStationImage(
      this.station.uuid
    );
    if (stationImage) {
      this.stationImage = stationImage;
    }
  }

  get onlineStatus (): OnlineStatusType {
    var current = moment();
    var lastOnline = moment(this.station.lastOnline);
    var diff = moment.duration(current.diff(lastOnline));
    if (diff.asMinutes() < 1) {
      return "ONLINE";
    }
    if (diff.asMinutes() < 15) {
      return "ISSUE";
    }
    return "OFFLINE";
  }

  get offlineDuration (): string {
    var current = moment();
    var lastOnline = moment(this.station.lastOnline);
    var diff = moment.duration(current.diff(lastOnline));
    return diff.locale("de").humanize();
  }

  get utilization (): number {
    if (this.station.maxUtilization === 0) return 0;
    return (
      (this.station.currentUtilization / this.station.maxUtilization) * 100
    );
  }

  get imageUrl () {
    if (this.stationImage) {
      return URL.createObjectURL(this.stationImage);
    }
    return undefined;
  }
}
